import { DefaultThemeInternal } from "../../../../internal/themes/DefaultTheme";
import { ThemeFactory } from "../../ThemeFactory";
export var DEFAULT_THEME = ThemeFactory.create({}, DefaultThemeInternal);